import axios from "axios";
import Vue from 'vue'

const $api_key = Vue.prototype.$api_key;
const $base_url = Vue.prototype.$base_url;

export const AliadosService = {
    getAliados(token = null, params = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        let config = {
            headers,
            params
        };
        return axios.get($base_url + "aliados/aliados", config, {
            headers: headers,
        })
    },
    getResumenAliados(token = null,params = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        let config = {
            headers: headers,
            params,
        };
        return axios.get($base_url + "aliados/resumen_aliados", config, {
            headers: headers,
        })
    },
    getAliado(token = null, params = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        let config = {
            headers: headers,
        };
        return axios.get( $base_url + "aliados/aliado/"+params, config, {
            headers: headers,
        })
    },
    getAnexosFicha(token = null, params = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        let config = {
            headers: headers,
        };
        return axios.get($base_url + "aliados/anexos_ficha/" + params,config,{
            headers: headers,
        })
    },
    setAliado(token = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        var params = {};
        return axios.post( $base_url + "aliados/set_aliado" , params, {
            headers: headers,
        })
    },
    setMailcontrato(token = null, params = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        return axios.post($base_url + "aliados/set_mail_contrato", params, {
            headers: headers,
        })
    },
    deleteAliado(token = null, params = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        return axios.post($base_url + "aliados/eliminar_aliado", params, {
            headers: headers,
        })
    },
    aprobarFirma(token = null, params = null){
        const headers = {
            "Content-Type": "application/json",
            "x-api-key": $api_key,
            token: token,
        };
        return axios.post($base_url + "aliados/aprobar_firma", params, {
            headers: headers,
        })
    }
};
export default { AliadosService };